import Cookies from 'js-cookie'
// 认证信息包括 token && 需要在发请求时带在 header 上
const TOKEN_KEY = 'ADMIN_TOKEN_OFFICIAL'
// 登录后的用户信息
const USER_KEY = 'USER_INFO'
const EXPIRES = 1 // 24 小时过期

export function getToken () {
  return Cookies.get(TOKEN_KEY)
}

// 获取url上的参数
export function GetQueryValue (queryName) {
  var query = decodeURI(window.location.search.substring(1))
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] === queryName) { return pair[1] }
  }
  return null
}

// token 信息
export function setToken (token) {
  return Cookies.set(TOKEN_KEY, token, { expires: EXPIRES })
}

export function removeToken () {
  return Cookies.remove(TOKEN_KEY)
}

// 登录用户基本信息
export function setUser (user) {
  return Cookies.set(USER_KEY, user, { expires: EXPIRES })
}

/**
 * 获取用户信息
 * 具体用户信息在 services/auth/index.js login方法中设置
 * @param { String } key 可选，用户信息中的键值
 */
export function getUser (key = '') {
  var user = Cookies.getJSON(USER_KEY)
  return key && user ? user[key] : (user || {})
}

// 删除用户信息
export function removeUser () {
  return Cookies.remove(USER_KEY)
}

// 判断用户是否登录
export function loggedIn () {
  return !!Cookies.get(TOKEN_KEY)
}
/**
   * 生成get的url
   * @param { String } url
   * @param { Object } params
   */
export function buildUrl (url, params) {
  let query = '?'
  for (var i in params) {
    query += i + '='
    query += params[i] + '&'
  }
  return url + query.slice(0, -1)
}

export const getQueryStr = (key) => {
  const queryString = window.location.search.match(
    new RegExp('[?&]' + key + '=([^&]*)(&?)', 'i')
  )
  const val = (queryString && queryString.length > 1 && queryString[1]) || ''
  return val
}
// 防抖debounce代码：
export function debounce (fn, delay = 1000) {
  var timeout = null // 创建一个标记用来存放定时器的返回值
  return function (e) {
    // 每当用户输入的时候把前一个 setTimeout clear 掉
    clearTimeout(timeout)
    // 然后又创建一个新的 setTimeout, 这样就能保证interval 间隔内如果时间持续触发，就不会执行 fn 函数
    timeout = setTimeout(() => {
      console.log('ok')
      fn.apply(this, arguments)
    }, delay)
  }
}

  /*
  * Javascript base64encode() base64加密函数
    用于生成字符串对应的base64加密字符串
  * @param string input 原始字符串
  * @return string 加密后的base64字符串
*/
export function base64Encode (input) {
  let rv = ''
  rv = encodeURIComponent(input)
  rv = unescape(rv)
  rv = window.btoa(rv)
  return rv
}

/**
 * 生成n位随机数
 * @param { Number }
 * @return { Number }
 */
export function randNumber (n) {
  var rnd = ''
  for (var i = 0; i < n; i++) {
    rnd += Math.floor(Math.random() * 10)
  }
  return rnd
}

export function getCountryNameZh () {}
export default {
  getToken,
  setToken,
  removeToken,
  setUser,
  getUser,
  removeUser,
  loggedIn,
  buildUrl,
  debounce,
  getCountryNameZh,
  randNumber,
  base64Encode
}
